import React from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";

/* =========================================================
   STORE CARD
========================================================= */

function StoreCard({
  imagenUrl,
  titulo,
  color,
  linkUrl,
  address,
  comingSoon,
}) {
  return (
    <div
      className={`store-card ${comingSoon ? "store-card-coming" : ""}`}
      style={{ "--store-color": color }}
    >
      <Link to={linkUrl} className="store-card-link">

        {/* IMAGE */}
        <div className="store-image-wrapper">

          {/* LOCATION ICON */}
          <div className="location-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 21C12 21 19 15.5 19 9.5C19 5.36 15.87 2 12 2C8.13 2 5 5.36 5 9.5C5 15.5 12 21 12 21Z"
                fill="currentColor"
              />
              <circle
                cx="12"
                cy="9.5"
                r="2.7"
                fill="white"
              />
            </svg>
          </div>

          <img
            src={imagenUrl}
            alt={titulo}
          />

          {comingSoon && (
            <div className="coming-soon-label">
              COMING SOON!
            </div>
          )}

        </div>

        {/* CONTENT */}
        <div className="store-card-content">

          <h2>{titulo}</h2>

          <div className="store-address">

            <svg
              className="small-location-icon"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 21C12 21 19 15.5 19 9.5C19 5.36 15.87 2 12 2C8.13 2 5 5.36 5 9.5C5 15.5 12 21 12 21Z"
                fill="currentColor"
              />
              <circle
                cx="12"
                cy="9.5"
                r="2.5"
                fill="white"
              />
            </svg>

            <span>{address}</span>

          </div>

          <div className="store-button">

            {comingSoon ? "Stay tuned" : "View Store"}

            <span className="button-arrow">
              {comingSoon ? "✦" : "→"}
            </span>

          </div>

        </div>

      </Link>
    </div>
  );
}


/* =========================================================
   STORES
========================================================= */

function Stores() {

  const stores = [
    {
      imagenUrl: "img/stores.png",
      titulo: "Ormiston Town Centre",
      color: "#23c4f4",
      linkUrl: "/claw-machine-location/1",
      address: "Ormiston Town Centre, Auckland",
    },
    {
      imagenUrl: "img/stores-2.png",
      titulo: "Sylvia Park",
      color: "#e93291",
      linkUrl: "/claw-machine-location/2",
      address: "Sylvia Park, Mount Wellington, Auckland",
    },
    {
      imagenUrl: "img/stores-3.png",
      titulo: "LynnMall",
      color: "#23c4f4",
      linkUrl: "/claw-machine-location/3",
      address: "LynnMall, New Lynn, Auckland",
    },
    {
      imagenUrl: "img/stores-4.jpg",
      titulo: "Dress Smart",
      color: "#e93291",
      linkUrl: "/claw-machine-location/4",
      address: "Dress Smart, Onehunga, Auckland",
    },
    {
      imagenUrl: "img/stores-5.jpg",
      titulo: "Shore City",
      color: "#23c4f4",
      linkUrl: "/claw-machine-location/5",
      address: "Shore City, Takapuna, Auckland",
    },
    {
      imagenUrl: "img/stores-cs.png",
      titulo: "Coming Soon",
      color: "#e93291",
      linkUrl: "/#Stores",
      address: "New store location",
      comingSoon: true,
    },
  ];


  return (
    <>
      <section className="our-Stores" id="Stores">

        <Fade
          triggerOnce
          cascade
          damping={0.08}
        >

          {/* TITLE */}
          <div className="stores-heading">

            <span className="heading-decoration">
              ✦
            </span>

            <h1>
              Visit Our Claw Machine Stores and Win Prizes!
            </h1>

            <span className="heading-decoration">
              ✦
            </span>

          </div>


          {/* INTRO */}
          <div className="stores-intro">

            <p className="stores-intro-title">
              Visit KraneStation's Claw Machine Stores at Ormiston Town Centre,
              Sylvia Park and Lynn Mall.
            </p>

            <p>
              Get ready for fun and prizes at our Claw Machine stores!
              Play your favorite claw machines and grab incredible prizes
              at KraneStation locations in Ormiston Town Centre, Sylvia Park
              and Lynn Mall. More exciting stores with awesome toys are
              coming soon! Don't miss out on the ultimate claw machine
              experience.
            </p>

          </div>


          {/* STORE CARDS */}
          <div className="stores-grid">

            {stores.map((store, index) => (
              <StoreCard
                key={index}
                {...store}
              />
            ))}

          </div>

        </Fade>

      </section>


      <style>{`

        /* =====================================================
           MAIN SECTION
        ===================================================== */

        .our-Stores {
          width: 100%;
          min-height: 100vh;

          padding: 75px 25px 100px;

          /*
            Background scales proportionally
            with the width of the screen.
          */
          background-image:
            linear-gradient(
              rgba(235, 248, 252, 0.35),
              rgba(235, 248, 252, 0.35)
            ),
            url('/img/background-stores.jpg');

          background-size: 100% auto;
          background-position: top center;
          background-repeat: repeat-y;
          background-attachment: scroll;

          box-sizing: border-box;

          display: flex;
          flex-direction: column;
          align-items: center;
        }


        /* =====================================================
           HEADING
        ===================================================== */

        .stores-heading {
          position: relative;

          display: flex;
          justify-content: center;
          align-items: center;

          width: fit-content;
          max-width: 1100px;

          margin: 0 auto 20px;
        }


        .stores-heading h1 {
          margin: 0;

          padding: 8px 26px;

          color: #009acd;

          font-size: 35px;
          line-height: 1.2;

          font-family:
            'Quicksand-Medium-Bold',
            'Quicksand',
            sans-serif;

          font-weight: 900;
          text-align: center;

          background: rgba(255, 255, 255, 0.82);

          border-radius: 4px;
        }


        .heading-decoration {
          color: #e93291;

          font-size: 26px;

          margin: 0 12px;

          animation: storeSparkle 2s infinite ease-in-out;
        }


        @keyframes storeSparkle {

          0%,
          100% {
            transform: scale(1);
            opacity: 0.7;
          }

          50% {
            transform: scale(1.25);
            opacity: 1;
          }

        }


        /* =====================================================
           INTRO
        ===================================================== */

        .stores-intro {
          width: 100%;
          max-width: 980px;

          margin: 0 auto 35px;

          padding: 20px 35px;

          background: rgba(255, 255, 255, 0.9);

          border-radius: 15px;

          box-shadow:
            0 8px 24px rgba(45, 75, 90, 0.12);

          box-sizing: border-box;

          text-align: center;

          font-family:
            'Quicksand',
            sans-serif;

          color: #262a34;
        }


        .stores-intro p {
          margin: 0;

          font-size: 17px;
          line-height: 1.45;
        }


        .stores-intro-title {
          font-weight: 800;
          margin-bottom: 3px !important;
        }


        /* =====================================================
           GRID
        ===================================================== */

        .stores-grid {
          width: 100%;
          max-width: 1050px;

          display: grid;

          grid-template-columns:
            repeat(3, minmax(0, 1fr));

          gap: 22px;

          margin: 0 auto;
        }


        /* =====================================================
           STORE CARD
        ===================================================== */

        .store-card {
          position: relative;

          overflow: hidden;

          min-width: 0;

          background: rgba(255, 255, 255, 0.97);

          border: 2px solid var(--store-color);
          border-radius: 15px;

          box-shadow:
            0 7px 20px rgba(25, 65, 85, 0.14);

          transition:
            transform 0.3s ease,
            box-shadow 0.3s ease;
        }


        .store-card:hover {
          transform: translateY(-8px);

          box-shadow:
            0 15px 35px rgba(25, 65, 85, 0.25);
        }


        .store-card-link {
          display: flex;
          flex-direction: column;

          height: 100%;

          text-decoration: none;

          color: inherit;
        }


        /* =====================================================
           STORE IMAGE
        ===================================================== */

        .store-image-wrapper {
          position: relative;

          margin: 10px 10px 0;

          height: 185px;

          overflow: hidden;

          border-radius: 9px;
        }


        .store-image-wrapper img {
          width: 100%;
          height: 100%;

          display: block;

          object-fit: cover;

          transition: transform 0.45s ease;
        }


        .store-card:hover .store-image-wrapper img {
          transform: scale(1.04);
        }


        /* =====================================================
           LARGE LOCATION ICON
        ===================================================== */

        .location-icon {
          position: absolute;

          z-index: 5;

          left: -1px;
          top: -1px;

          width: 43px;
          height: 43px;

          display: flex;
          align-items: center;
          justify-content: center;

          color: var(--store-color);

          background: white;

          border: 3px solid var(--store-color);
          border-radius: 50%;

          box-shadow:
            0 2px 6px rgba(0, 0, 0, 0.12);
        }


        .location-icon svg {
          width: 27px;
          height: 27px;
        }


        /* =====================================================
           COMING SOON
        ===================================================== */

        .coming-soon-label {
          position: absolute;

          z-index: 4;

          left: 50%;
          top: 50%;

          width: 125%;

          padding: 10px;

          transform:
            translate(-50%, -50%)
            rotate(-32deg);

          background: rgba(255, 255, 255, 0.87);

          color: #e93291;

          text-align: center;

          font-family:
            'Quicksand',
            sans-serif;

          font-size: 17px;

          font-weight: 900;

          letter-spacing: 0.5px;
        }


        /* =====================================================
           CARD CONTENT
        ===================================================== */

        .store-card-content {
          padding: 13px 14px 14px;

          display: flex;
          flex-direction: column;

          flex-grow: 1;
        }


        .store-card-content h2 {
          margin: 0 0 8px;

          color: var(--store-color);

          font-family:
            'Quicksand-Medium-Bold',
            'Quicksand',
            sans-serif;

          font-size: 19px;

          line-height: 1.2;

          font-weight: 900;

          text-align: left;
        }


        /* =====================================================
           ADDRESS
        ===================================================== */

        .store-address {
          display: flex;

          align-items: flex-start;

          gap: 7px;

          min-height: 40px;

          margin-bottom: 13px;

          color: #424750;

          font-family:
            'Quicksand',
            sans-serif;

          font-size: 12.5px;

          line-height: 1.4;
        }


        .small-location-icon {
          width: 14px;
          height: 14px;

          min-width: 14px;

          margin-top: 2px;

          color: var(--store-color);
        }


        /* =====================================================
           BUTTON
        ===================================================== */

        .store-button {
          width: 100%;
          height: 40px;

          margin-top: auto;

          display: flex;

          align-items: center;
          justify-content: center;

          gap: 14px;

          background: var(--store-color);

          color: white;

          border-radius: 5px;

          font-family:
            'Quicksand',
            sans-serif;

          font-size: 14px;

          font-weight: 800;

          transition:
            filter 0.25s ease,
            transform 0.25s ease;
        }


        .store-card:hover .store-button {
          filter: brightness(0.93);
        }


        .button-arrow {
          font-size: 20px;

          transition: transform 0.25s ease;
        }


        .store-card:hover .button-arrow {
          transform: translateX(5px);
        }


        /* =====================================================
           TABLET / SMALL DESKTOP
        ===================================================== */

        @media screen and (max-width: 1050px) {

          .our-Stores {
            background-size: 100% auto;
            background-position: top center;
          }

          .stores-grid {
            max-width: 720px;

            grid-template-columns:
              repeat(2, minmax(0, 1fr));
          }

          .stores-heading h1 {
            font-size: 31px;
          }

          .stores-intro {
            max-width: 720px;
          }

        }


        /* =====================================================
           TABLET / MOBILE
        ===================================================== */

        @media screen and (max-width: 768px) {

          .our-Stores {
            min-height: auto;

            padding: 55px 18px 70px;

            /*
              Background keeps its original
              aspect ratio while screen shrinks.
            */
            background-size: 100% auto;
            background-position: top center;
            background-repeat: repeat-y;
            background-attachment: scroll;
          }


          .stores-heading {
            width: 100%;
          }


          .stores-heading h1 {
            width: 100%;

            font-size: 27px;

            padding: 10px 14px;
          }


          .heading-decoration {
            display: none;
          }


          .stores-intro {
            width: 100%;

            padding: 18px 20px;

            margin-bottom: 28px;
          }


          .stores-intro p {
            font-size: 15px;
          }


          .stores-grid {
            max-width: 620px;

            grid-template-columns:
              repeat(2, minmax(0, 1fr));

            gap: 15px;
          }


          .store-image-wrapper {
            height: 155px;
          }


          .store-card-content h2 {
            font-size: 17px;
          }


          .store-address {
            font-size: 11px;
          }

        }


        /* =====================================================
           SMALL MOBILE
        ===================================================== */

        @media screen and (max-width: 520px) {

          .our-Stores {
            padding: 50px 15px 65px;

            background-size: 100% auto;
            background-position: top center;
            background-repeat: repeat-y;
          }


          .stores-heading h1 {
            font-size: 24px;
          }


          .stores-grid {
            grid-template-columns: 1fr;

            max-width: 355px;

            gap: 22px;
          }


          .store-image-wrapper {
            height: 190px;
          }


          .store-card-content {
            padding: 13px 14px 15px;
          }


          .store-card-content h2 {
            font-size: 20px;
          }


          .store-address {
            min-height: auto;

            font-size: 12.5px;

            margin-bottom: 15px;
          }


          .store-button {
            height: 42px;
          }

        }

      `}</style>
    </>
  );
}

export default Stores;